module.exports = __webpack_public_path__ + "static/keyword-ee820654c933036de9f118674b0bb027.png";